module.exports = __webpack_public_path__ + "static/img/gws_home_testimonials.40db09f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gws_home_testimonials.png
// module id = j1RY
// module chunks = 1